// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ColumnHeader, ColumnHeaderSchema } from 'api/gen/ColumnHeader';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagement, PagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema } from 'api/gen/PagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagement';

const requiredPart = t.interface({
  headers: t.union([t.array(ColumnHeaderSchema), t.null]),
  pagedModel: PagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema,
});

export const DynamicPagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema = excess(requiredPart);

export interface DynamicPagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagement extends t.TypeOf<typeof DynamicPagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema> {}
